var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 282,
    viewBox: "0 0 211 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1505_129",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 97,
    width: 210,
    height: 185
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.327 97.7225C105.255 97.1866 106.399 97.1866 107.327 97.7225L209.084 156.472C210.012 157.008 210.584 157.998 210.584 159.07V275.389C210.584 277.011 209.295 278.339 207.674 278.388L105.827 281.425L3.98088 278.388C2.35957 278.339 1.07031 277.011 1.07031 275.389V159.07C1.07031 157.998 1.64211 157.008 2.57031 156.472L104.327 97.7225Z",
    fill: "#222C34"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1505_129)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10.0566,
    y: 141.109,
    width: 238.939,
    height: 125.152,
    fill: "url(#paint0_linear_1505_129)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.999 0.0371094L209.756 60.5186V141.481L104.999 201.963L0.242188 141.481V60.5186L104.999 0.0371094Z",
    fill: "#212B34"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1505_129",
    x1: 109.413,
    y1: 141.109,
    x2: 109.413,
    y2: 266.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222C34",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#212B34",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1505_129",
    x1: 104.826,
    y1: 0.0371094,
    x2: 104.826,
    y2: 120.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FEE76",
    stopOpacity: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackBox);
export default __webpack_public_path__ + "static/media/black-box.0c6c73c26d9373ce58df7797d69aa545.svg";
export { ForwardRef as ReactComponent };